import sales from '../../../services/sales';
import param from '../../../services/param';
import messageDialog from '../../../components/message-dialog.vue';
import Reprocess from './reprocess.vue';

export default {

  data() {
    return {
      order: undefined,
      address: undefined,
      loading: undefined,
      orderShipmentTracking: undefined,
      showVehicle: false,
      listVehicles: [],
      statusPedido: {},
      showModal: false,
      dataCorteReprocessamento: undefined,
      newTypePayment: undefined,
      reprocessed: false
    }
  },

  computed:{
    notAproved(){
      return this.$route.query.notAproved
    },
    orderId(){
      return this.$route.params.orderId
    }
  },
  mounted: function () {
    let promise = sales.getSalesOrderId(this.orderId).then(r => {
      this.order = r;
      if (this.order.shipment)
      this.orderShipmentTracking = this.order.shipment.orderShipmentTrackingList.orderShipmentTracking;

      this.statusPedido['status-active'] = this.order.status.statusId == 2 || this.order.status.statusId == 4 || this.order.status.statusId == 7;
      this.statusPedido['status-inactive'] = !this.statusPedido['status-active'];

      if (this.order.shipment && this.order.shipment.listVehicle)
        this.listVehicles = this.order.shipment.listVehicle.vehicle;

      if (this.order.shipment) {
        this.address = this.order.shipment.address.zipCode.address + ' ' + this.order.shipment.address.number + ', ' + this.order.shipment.address.zipCode.neighborhood +
          ' - CEP ' + this.order.shipment.address.zipCode.zipCode + ' - ' + this.order.shipment.address.zipCode.city + ' - ' +
          this.order.shipment.address.zipCode.state;
      }
    });
    this.$store.dispatch('loading', promise);


    param.getParm().then(res => {
      this.dataCorteReprocessamento = res.data.dataCorteReprocessamento;
    }).catch(erro => {
      messageDialog.show({
        title: 'Erro',
        message: 'Não foi possivel carregar a data de corte para processamento!',
        type: 'OK'
      });
    });

  },
  methods: {
   
    toogleModal() {
      this.showVehicle = !this.showVehicle;
    },
    canReprocess(){
      if (!this.order || this.dataCorteReprocessamento === undefined) return false;
      const pm = this.order.paymentMethod;
      const dateOk = parseInt(this.dataCorteReprocessamento, 10) < new Date().getTime();
      const statusPending = this.order.status.statusId == 3 && dateOk;
      const bcPending = pm && pm.type == 'BC' && !this.order.bankBillUrl && this.order.price > 0;
      return statusPending || bcPending;
    },
    showModalReprocessPayout() {
      this.showModal = true;
    },
    isDescont(product,value){
      return product.productId == 11 ? (-1) * value : value;
    },
    showVehiclesPlates(product){
      let productsException = [1,4,6];
      return  this.order.promotionCode != 'CAMINHOSDOPARANA' && productsException.includes(product.productId);
    },
    goToOrders(sucess){
      this.$router.push({name: 'requests'});
    }

  },
  components:{
    Reprocess
  }

}



// WEBPACK FOOTER //
// ./src/pages/account/request/request-detail.js